export const updateFontSizeDynamically = (elementRef, onWidth = false, defaultFontSize = 14, minFontSize = 10) => {
  elementRef.style.fontSize = defaultFontSize + 'px'

  // eslint-disable-next-line no-unmodified-loop-condition
  while (true) {
    const scrollDimension = onWidth ? elementRef.scrollWidth : elementRef.scrollHeight
    const clientDimension = onWidth ? elementRef.clientWidth : elementRef.clientHeight

    const currentFontSize = parseInt(window.getComputedStyle(elementRef).fontSize)
    if (scrollDimension <= clientDimension || currentFontSize <= minFontSize) {
      break
    }

    elementRef.style.fontSize = `${currentFontSize - 1}px`
    elementRef.style.lineHeight = `${currentFontSize - 1}px`
  }
}
